import type { UseCasePageData } from '../../lib/useCaseQueries';
import { normalizeUseCasePage } from '../../lib/useCaseNormalize';
import { resolveSectionBands } from '../../lib/useCaseSectionGuards';
import '../../styles/product-landing.css';
import '../../styles/solutions-landing.css';
import '../../styles/table-block.css';
import '../../styles/use-case.css';
import { SectionRenderer } from './sections/SectionRenderer';

type UseCasePageProps = {
  data: UseCasePageData;
};

export function UseCasePage({ data }: UseCasePageProps) {
  const sections = normalizeUseCasePage(data);
  const bands = resolveSectionBands(sections);

  return (
    <div className="product-page solutions-page use-case-page">
      {sections.map((section) => {
        const tone = bands.get(section._key) ?? 'dark';
        return (
          <SectionRenderer
            key={section._key}
            section={section}
            tone={tone}
          />
        );
      })}
    </div>
  );
}
